export default {
  sportsbook: "Sportsbook Agent",
  login_page: "Sportsbook Agent Site",
  first_time_page: "เข้าสู่ระบบแรก",
  security_page: "การรับรองความปลอดภัย",
  account_settings: "การตั้งค่าบัญชี",
  new_login: "ใหม่เข้าสู่ระบบ",
  two_step_verification: "การยืนยันแบบสองขั้นตอน",
  account_information: "ข้อมูลเกี่ยวกับบัญชี",
  commission_settings: "การตั้งค่า คอมมิชชั่น",
  bet_limit_settings: "การตั้งค่า จำกัดการเดิมพัน",
  position_taking_settings: "เปอร์เซ็นที่รับความเสี่ยงการตั้งค่า",
  update_profile: "ข้อมูลส่วนตัวล่าสุด",
  update_password: "รหัสผ่าน ปรับปรุง",
  update_security: "การปรับปรุงความปลอดภัย",
  account_profile: "ข้อมูลส่วนตัวรหัสผู้ใช้",
  account_creation: "Account Creation",
  profile_settings: "ข้อมูลส่วนตัวการตั้งค่า",
  otp_page: "หน้า OTP",
  unbind_otp_2fa: "ยกเลิก OTP 2FA",
  unbind_otp_telegram: "ยกเลิก OTP Telegram",
  high_roller_platform: "ที่สูงสุดของผู้เล่น"
};